import { postAPI , getAPI } from "../../api/api";
import { REACT_APP_CUSTOMER , REACT_APP_RECRUITER } from "../../utils/common";


export async function submitCompanyDetails(data: any){
    const Details = postAPI(  REACT_APP_CUSTOMER  + `/customer-details`, data)
    return Details
}

export async function getUserDetails(email: string, customerType: number) {
    const Details = getAPI( REACT_APP_CUSTOMER + `/email-validation/${email}?customerType=${customerType}`);
    return Details;
}

export async function getRecruiterList() {
    const Details = getAPI( REACT_APP_RECRUITER + "/list")
    return Details
}

export async function getCompanyDetails(companyName: string) {
    const Details = getAPI( REACT_APP_CUSTOMER + `/company-details/${companyName}`);
    return Details;
}
